import { useState } from "react";

import { PlayerCreation } from "./PlayerCreation";
import { F1K_Intro } from "./Intro";
import MainButton from "../components/MainButton";
import { PopUp } from "../components/PopUp";
import { Game } from "./Game";
import { GuideProvider } from "./GuideContext";
import { LeaderboardProvider } from "./LeaderboardContext";

import { useSessionPlayer } from "../SessionPlayerContext";

import ExtraAudio from "../ExtraAudio.js";

import imgSoundOn from "../assets/images/soundon.png";
import imgSoundOff from "../assets/images/soundoff.png";

window.ExtraAudio = ExtraAudio;

export const FangoWrapper = () => {
  const { player } = useSessionPlayer();

  const [showCredits, setShowCredits] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [isLanding, setIsLanding] = useState(true);
  const [isIntro, setIsIntro] = useState(false);

  ExtraAudio.onChangeMute = () => {
    setIsMuted(ExtraAudio.muted);
  };

  const [guideState, setGuideState] = useState({ statement: "" });
  const [leaderboardState, setLeaderboardState] = useState({ ranking: [] });

  return (
    <LeaderboardProvider value={{ leaderboardState, setLeaderboardState }}>
      <div className="fango-base">
        <header className="fango-base--header">
          <h1 className="fango-border-text fango-border-text__greyed fango-main-title">
            <span>Fango 1000</span>
          </h1>
          <MainButton
            className="fango-about"
            name="About"
            onClick={() => setShowCredits(true)}
          />
          {isLanding && (
            <div className="fango-restart">
              <MainButton
                className="btn-start-game"
                name="Click to start"
                onClick={() => {
                  setShowCredits(false);
                  ExtraAudio.start();
                  setIsLanding(false);
                  setIsIntro(true);
                }}
              />
            </div>
          )}
          <div className="fango-mute">
            {!isLanding && (
              <button
                onClick={() => {
                  if (ExtraAudio.muted) {
                    ExtraAudio.unmute();
                    ExtraAudio.sfxSample("click");
                  } else {
                    ExtraAudio.mute();
                  }
                }}
                className={`fango-main-button fango-mute-button ${isMuted ? "muted" : "unmuted"}`}
                type="button"
                style={{ backgroundImage: isMuted ? imgSoundOff : imgSoundOn }}
              >
                <span className="text">{isMuted ? "unmute" : "mute"}</span>
              </button>
            )}
          </div>
          <div className="fango-connect" />
        </header>

        {!isLanding && (
          <GuideProvider value={{ guideState, setGuideState }}>
            {isIntro ? (
              <F1K_Intro onStart={() => setIsIntro(false)} />
            ) : player ? (
              <Game />
            ) : (
              <PlayerCreation />
            )}
          </GuideProvider>
        )}

        {isLanding && <div className="fango-landing-image" />}

        {showCredits && (
          <PopUp className="fango-credits pop-up__large" onClick={() => setShowCredits(false)}>
            <div>
              <p style={{ fontWeight: "bold", fontStyle: "italic" }}>Fango 1000</p>
              <p>
                an onchain* narrative game by{" "}
                <a href="https://dmstfctn.net/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit" }}>
                  dmstfctn.
                </a>
              </p>
              <p>
                Writing, development, design: dmstfctn
                <br />
                Additional writing: Mina Amiri Kalvøy
                <br />
                Soundtrack: Hero Image
                <br />
                Illustrations: Carlo Crivelli (†1495) and dmstfctn
                <br />
                Additional MUD and solidity development: Paul Seidler
                <br />
                <br />
                Supported by: Mask Network, MEET Digital Culture Center, Baltan Laboratories, and Etopia.
                <br />
                <br />
                <span style={{ fontStyle: "italic" }}>Fango 1000</span> is a prototype of a{" "}
                <a href="https://aw.network/posts/large-lore-models" target="_blank" rel="noopener noreferrer" style={{ color: "inherit" }}>
                  Large Lore Model
                </a>
                , a tool hypothesised by dmstfctn, Eva Jäger and Alasdair Milne to connect existing onchain data with user stories and perspectives.
                <br />
                <br />
                *Fango 1000 has been archived <a href="https://lattice.xyz/winding-down" target="_blank" rel="noopener noreferrer" style={{ color: "inherit" }}>off chain</a>. You can still play the game, but your actions will not be saved.
              </p>              
            </div>
          </PopUp>
        )}
      </div>
    </LeaderboardProvider>
  );
};
